import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentMenuComponent } from './content-menu/content-menu.component'
import { ContentDisplayComponent,SafeHtmlPipe } from './content-display/content-display.component'
import { ContentImageComponent } from './content-image/content-image.component'
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';


@NgModule({
  declarations: [
    ContentMenuComponent,
    ContentDisplayComponent,
    ContentImageComponent,
    SafeHtmlPipe,
  ],
  entryComponents: [
    ContentMenuComponent,
    ContentDisplayComponent,
    ContentImageComponent,
  ],
  imports: [
    CommonModule,
    IonicModule.forRoot(),
    RouterModule,
  ],
  exports: [
    ContentMenuComponent,
    ContentDisplayComponent,
    ContentImageComponent,
  ]
})
export class ECGComponentsModule { }
